<template>
  <div class="w-100 overlay">
    <slick ref="slick" :options="slickOptions" class="slider-for card-sqr-gray ios-slider-wrapper" @setPosition="handleSetPosition">
      <div class="disp-us ios-slider-preview-wrap" v-for="(images, index) in projectImages" :key="index">
        <img :src="images.imagePath" :data-image-number="images.imageNumber" :data-bookmark="images.bookmark" :data-file-name="images.fileName" :key="index" class="ar-3-2">
        <div class="position-relative">
          <img src="~@/assets/img/heart-active.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-show="showBookmarkIcon && images.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
          <img src="~@/assets/img/heart-passive.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-show="showBookmarkIcon && !images.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
        </div>
      </div>
    </slick>

    <div class="col-sm-12 mb-4">
      <slick ref="slickNav" :options="slickNavOptions" class="slider-nav card-sqr-gray">
        <div class="w-100 disp-us ios-slider-img-wrap" v-for="(images, index) in projectImages" :key="index">
          <img :src="images.imagePath" :key="index" class="ar-3-2">
          <div class="position-relative">
            <img src="~@/assets/img/heart-active.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-show="showBookmarkIcon && images.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
            <img src="~@/assets/img/heart-passive.png" class="position-absolute like-icon" style="right: 10px; bottom: 10px;" v-show="showBookmarkIcon && !images.bookmark && routeProjectType !== 'お客様画像' && routeProjectType !== '持ち帰り'">
          </div>
        </div>
      </slick>
    </div>
  </div>
</template>
<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'ProductSelectionSlider',
  props: {
    projectImages: Object,
    routeProjectType: String,
    showBookmarkIcon: { type: Boolean, default: true }
  },
  components: { Slick },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        asNavFor: '.slider-nav',
        swipe: false,
        dots: true, // ドットマーク
        dotsClass: 'slick-dots',
        prevArrow: '<div class="slick-prev" id="slick-prev"></div>', // ひとつ前の画像に戻る矢印ボタン
        nextArrow: '<div class="slick-next" id="slick-next"></div>' // ひとつ先の画像に進む矢印ボタン
      },
      slickNavOptions: {
        slidesToShow: 4,
        asNavFor: '.slider-for',
        arrows: false,
        focusOnSelect: true
      }
    }
  },
  watch: {
    projectImages: function (newData, oldData) {
      this.reInit()
    }
  },
  // All slick methods can be used too, example here
  methods: {
    next () {
      this.$refs.slick.next()
    },

    prev () {
      this.$refs.slick.prev()
    },

    reInit () {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$refs.slick.destroy()
      this.$refs.slickNav.destroy()
      this.$nextTick(() => {
        this.$refs.slick.create()
        this.$refs.slickNav.create()
      })
    },
    clickEvent (event) {
      const dotsParentElm = document.getElementsByClassName('slick-dots')[0]
      const dotsElms = dotsParentElm.childNodes // 全ドットマーク
      const lastElmId = dotsElms.length - 1 // 一番後ろの要素
      const currentElm = document.getElementsByClassName('slick-active')[1]
      const currentId = Number(currentElm.id.split('-')[1]) // 今いる位置のindex
      let id = event.target.id
      if (id === 'slick-prev') { // 左矢印の場合
        if (currentId === 0) { // 今が0番目なら一番後ろの要素に
          id = 'dots-' + lastElmId
        } else { // それ以外なら一つ手前に
          id = 'dots-' + (currentId - 1)
        }
      } else if (id === 'slick-next') { // 右矢印の場合
        if (currentId === lastElmId) { // 今が一番後ろなら0番目の要素に
          id = 'dots-0'
        } else { // それ以外なら一つ先に
          id = 'dots-' + (currentId + 1)
        }
      }
      console.log(id)
      this.$emit('sendSignaling', id)
    },
    // Events listeners
    handleAfterChange (event, slick, currentSlide) {
    },
    handleBeforeChange (event, slick, currentSlide, nextSlide) {
    },
    handleBreakpoint (event, slick, breakpoint) {
    },
    handleDestroy (event, slick) {
    },
    handleEdge (event, slick, direction) {
    },
    handleInit (event, slick) {
    },
    handleReInit (event, slick) {
    },
    handleSetPosition (event, slick) {
      const prevElm = document.getElementById('slick-prev')
      if (prevElm) {
        prevElm.addEventListener('click', this.clickEvent, false)
        prevElm.id = 'slick-prev'
      }
      const nextElm = document.getElementById('slick-next')
      if (nextElm) {
        nextElm.addEventListener('click', this.clickEvent, false)
        nextElm.id = 'slick-next'
      }
      const dotsParentElm = document.getElementsByClassName('slick-dots')[0]
      if (dotsParentElm) {
        const dotsElms = dotsParentElm.childNodes
        if (dotsElms) {
          for (let i = 0; i < dotsElms.length; i++) {
            dotsElms.item(i).addEventListener('click', this.clickEvent, false)
            dotsElms.item(i).id = 'dots-' + i
          }
        }
      }
      const sliderNavAncestorElm = document.getElementsByClassName('slider-nav')[0]
      if (sliderNavAncestorElm) {
        const sliderNavParentElm = sliderNavAncestorElm.querySelectorAll('.slick-track')[0]
        if (sliderNavParentElm) {
          const sliderNavElm = sliderNavParentElm.childNodes
          if (sliderNavElm) {
            for (let i = 0; i < sliderNavElm.length; i++) {
              const imgElm = sliderNavElm.item(i).querySelectorAll('img')[0]
              imgElm.addEventListener('click', this.clickEvent, false)
              imgElm.id = 'nav-' + i
            }
          }
        }
      }
      if (typeof document.getElementsByClassName('slick-current')[0] !== 'undefined') {
        // メインスライダー画像のタイプをチェック
        this.$emit('checkImageNumber')
        // メインスライダー画像のブックマークの有無をチェック
        this.$emit('checkBookmark')
      }
    },
    handleSwipe (event, slick, direction) {
    },
    handleLazyLoaded (event, slick, image, imageSource) {
    },
    handleLazeLoadError (event, slick, image, imageSource) {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductSelectionSlider.vue